// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MobileSideMenu_wrapper__fAtLB {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  background-color: rgb(0, 0, 0, 0.3);
}

.MobileSideMenu_hidden__BGUUC {
  display: none;
}

.MobileSideMenu_exit__QA39h {
  position: relative;
  top: 0;
  left: 30px;
  width: 35px;
}

.MobileSideMenu_exit__QA39h:hover {
  cursor: pointer;
}

.MobileSideMenu_sidebar__KYmHW {
  height: 100vh;
  background-color: white;
  width: 50%;
  padding: 20px 0;
  overflow-y: scroll;
  box-sizing: border-box;
}

.MobileSideMenu_user__S\\+77E {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.MobileSideMenu_userPhoto__-g8aw {
  border: 1px solid #e2e2e2;
  border-radius: 55px;
  height: 80px;
  width: 80px;
}
.MobileSideMenu_userInfoContainer__ipS6V {
  display: flex;
  flex-direction: column;
  padding-top: 10px;
}
.MobileSideMenu_userNameText__1kKUj {
  color: #4d4d4d;
  font-family: "Inter";
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.001em;
  margin: 0px;
  text-transform: capitalize;
  text-align: center;
}
.MobileSideMenu_userRoleText__mMb0Z {
  color: #4d4d4d;
  font-family: "Inter";
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.001em;
  margin: 0px;
  text-transform: capitalize;
  text-align: center;
}
.MobileSideMenu_items__9eGN4 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
  row-gap: 4px;
}
.MobileSideMenu_helpItemContainer__wVDW0 {
  padding-top: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.MobileSideMenu_item__WajCy {
  align-items: center;
  column-gap: 12px;
  cursor: pointer;
  display: flex;
  height: 48px;
  padding: 0px 16px;
  transition: all 250ms ease-in-out;
  width: 198px;
}
.MobileSideMenu_item__WajCy:hover {
  background-color: #e6e6e6;
  border-radius: 4px;
}
.MobileSideMenu_itemActive__h\\+s5Q {
  align-items: center;
  background-color: #cb9c2d;
  border-radius: 4px;
  column-gap: 12px;
  cursor: pointer;
  display: flex;
  height: 48px;
  padding: 0px 16px;
  transition: all 250ms ease-in-out;
  width: 198px;
}
.MobileSideMenu_itemActive__h\\+s5Q .MobileSideMenu_itemText__l9nnQ {
  color: #fff;
}
.MobileSideMenu_itemText__l9nnQ {
  color: #5f6d7e;
  cursor: pointer;
  font-family: "Inter";
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  margin: 0px;
}
.MobileSideMenu_itemIcon__\\+uaQE {
  height: 22px;
  width: 22px;
  stroke: #5f6d7e;
}
.MobileSideMenu_itemActive__h\\+s5Q .MobileSideMenu_itemIcon__\\+uaQE {
  filter: brightness(1000%);
}
.MobileSideMenu_separator__qpmpJ {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 16px 0px 16px 16px;
}
.MobileSideMenu_spanSeparator__ayPlh {
  font-family: "Inter";
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.001em;
  text-align: left;
  color: #9fa7b2;
}
.MobileSideMenu_divider__ix8sk {
  width: 134px;
  border: 1px solid #e0e0e0;
}

@media screen and (max-width: 700px) {
  .MobileSideMenu_sidebar__KYmHW {
    width: 70%;
  }
}

@media screen and (max-width: 400px) {
  .MobileSideMenu_sidebar__KYmHW {
    width: 88%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MobileSideMenu/MobileSideMenu.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,iCAAiC;EACjC,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,iCAAiC;EACjC,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,2BAA2B;AAC7B;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":[".wrapper {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100%;\n  background-color: rgb(0, 0, 0, 0.3);\n}\n\n.hidden {\n  display: none;\n}\n\n.exit {\n  position: relative;\n  top: 0;\n  left: 30px;\n  width: 35px;\n}\n\n.exit:hover {\n  cursor: pointer;\n}\n\n.sidebar {\n  height: 100vh;\n  background-color: white;\n  width: 50%;\n  padding: 20px 0;\n  overflow-y: scroll;\n  box-sizing: border-box;\n}\n\n.user {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.userPhoto {\n  border: 1px solid #e2e2e2;\n  border-radius: 55px;\n  height: 80px;\n  width: 80px;\n}\n.userInfoContainer {\n  display: flex;\n  flex-direction: column;\n  padding-top: 10px;\n}\n.userNameText {\n  color: #4d4d4d;\n  font-family: \"Inter\";\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 28px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n  text-transform: capitalize;\n  text-align: center;\n}\n.userRoleText {\n  color: #4d4d4d;\n  font-family: \"Inter\";\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n  text-transform: capitalize;\n  text-align: center;\n}\n.items {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-top: 40px;\n  row-gap: 4px;\n}\n.helpItemContainer {\n  padding-top: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n.item {\n  align-items: center;\n  column-gap: 12px;\n  cursor: pointer;\n  display: flex;\n  height: 48px;\n  padding: 0px 16px;\n  transition: all 250ms ease-in-out;\n  width: 198px;\n}\n.item:hover {\n  background-color: #e6e6e6;\n  border-radius: 4px;\n}\n.itemActive {\n  align-items: center;\n  background-color: #cb9c2d;\n  border-radius: 4px;\n  column-gap: 12px;\n  cursor: pointer;\n  display: flex;\n  height: 48px;\n  padding: 0px 16px;\n  transition: all 250ms ease-in-out;\n  width: 198px;\n}\n.itemActive .itemText {\n  color: #fff;\n}\n.itemText {\n  color: #5f6d7e;\n  cursor: pointer;\n  font-family: \"Inter\";\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n}\n.itemIcon {\n  height: 22px;\n  width: 22px;\n  stroke: #5f6d7e;\n}\n.itemActive .itemIcon {\n  filter: brightness(1000%);\n}\n.separator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 16px 0px 16px 16px;\n}\n.spanSeparator {\n  font-family: \"Inter\";\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #9fa7b2;\n}\n.divider {\n  width: 134px;\n  border: 1px solid #e0e0e0;\n}\n\n@media screen and (max-width: 700px) {\n  .sidebar {\n    width: 70%;\n  }\n}\n\n@media screen and (max-width: 400px) {\n  .sidebar {\n    width: 88%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `MobileSideMenu_wrapper__fAtLB`,
	"hidden": `MobileSideMenu_hidden__BGUUC`,
	"exit": `MobileSideMenu_exit__QA39h`,
	"sidebar": `MobileSideMenu_sidebar__KYmHW`,
	"user": `MobileSideMenu_user__S+77E`,
	"userPhoto": `MobileSideMenu_userPhoto__-g8aw`,
	"userInfoContainer": `MobileSideMenu_userInfoContainer__ipS6V`,
	"userNameText": `MobileSideMenu_userNameText__1kKUj`,
	"userRoleText": `MobileSideMenu_userRoleText__mMb0Z`,
	"items": `MobileSideMenu_items__9eGN4`,
	"helpItemContainer": `MobileSideMenu_helpItemContainer__wVDW0`,
	"item": `MobileSideMenu_item__WajCy`,
	"itemActive": `MobileSideMenu_itemActive__h+s5Q`,
	"itemText": `MobileSideMenu_itemText__l9nnQ`,
	"itemIcon": `MobileSideMenu_itemIcon__+uaQE`,
	"separator": `MobileSideMenu_separator__qpmpJ`,
	"spanSeparator": `MobileSideMenu_spanSeparator__ayPlh`,
	"divider": `MobileSideMenu_divider__ix8sk`
};
export default ___CSS_LOADER_EXPORT___;
